<template lang="html">
    <div v-if="players.length > 0">
        <h2 class="h5 font-weight-bold">In the room:</h2>
        <ul
            class="list-unstyled my-0 row flex-nowrap flex-md-wrap lobby-members pt-3"
        >
            <li
                v-for="player in players"
                :key="player.player_id"
                class="col-3 col-sm-2 col-md-4 mb-md-4 member"
                :class="{
                    'is-turn':
                        player.player_id === $store.state.room.turn.player_id,
                    'disconnected': !player.connected,
                }"
                :style="{ color: player.colour }"
            >
                <div class="status-wrap">
                    <div class="status-wrap__top">
                        <transition name="scale">
                            <span
                                v-if="player.heaven_master"
                                class="status status-heavenmaster"
                                >🙌</span
                            >
                        </transition>
                        <transition name="scale">
                            <span
                                v-if="player.thumb_master"
                                class="status status-thumbmaster"
                                >👍</span
                            >
                        </transition>
                        <transition name="scale">
                            <span
                                v-if="player.question_master"
                                class="status status-questionmaster"
                                >❓</span
                            >
                        </transition>
                    </div>
                    <avatar
                        :name="player.name"
                        :colour="player.colour"
                        width="60"
                    ></avatar>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

export default {
    computed: {
        players() {
            return this.$store.state.room.players;
        },
    },
    components: {
        Avatar,
    },
};
</script>
